import backend, {WORKFLOW_ENGINE_API} from 'utils/backend/server/api_library';

const createPlaybook = (body) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook`;
  return backend.post(url, body);
};

const listPlaybooks = () => {
  const url = `${WORKFLOW_ENGINE_API}/playbook`;
  return backend.get(url);
};

const getPlaybook = (playbookRn) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}`;
  return backend.get(url);
};

const updatePlaybookContent = (playbookRn, body) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}`;
  return backend.put(url, body);
};

const deletePlaybook = (playbookRn) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}`;
  return backend.delete(url);
};

const addPlaybookStep = (playbookRn, body) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}/step`;
  return backend.post(url, body);
};

const updatePlaybookStep = (playbookRn, stepRn, body) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}/step/${stepRn}`;
  return backend.put(url, body);
};

const removePlaybookStep = (playbookRn, stepRn) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}/step/${stepRn}`;
  return backend.delete(url);
};

const executePlaybook = (playbookRn, resourceRn) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}/execution`;
  const body = {
    resourceRn,
  };
  return backend.post(url, body);
};

const getPlaybookExecution = (playbookRn, executionRn) => {
  const url = `${WORKFLOW_ENGINE_API}/playbook/${playbookRn}/execution/${executionRn}`;
  return backend.get(url);
};

export default {
  create: createPlaybook,
  list: listPlaybooks,
  get: getPlaybook,
  update: updatePlaybookContent,
  delete: deletePlaybook,

  step: {
    add: addPlaybookStep,
    update: updatePlaybookStep,
    remove: removePlaybookStep,
  },

  execution: {
    create: executePlaybook,
    get: getPlaybookExecution,
  },
};
